import React, { useState, useEffect, useRef, useCallback } from "react";
import { AppState } from "react-native";
import { useFocusEffect, useIsFocused } from "@react-navigation/native";
import { actions as configActions } from "@reducers/configReducer";
import { actions as refreshActions } from "@reducers/refreshReducer";
import { actions as cartActions } from "@reducers/cartReducer";
import { useSelector, useDispatch } from "react-redux";
import { actions as qtySelectActions } from "@reducers/qtySelectReducer";

import messaging from "@react-native-firebase/messaging";

const refreshHOC =
  (screenName = "") =>
  (WrappedComponent) => {
    return function (props) {
      const { lastFeedRefreshTimestamp, feedStaleDelayMs } = useSelector(
        (state) => state.refresh,
      );
      const random = useRef(Math.random()).current;

      const { selectedContact } = useSelector((state) => state.customer);
      const appState = useRef(AppState.currentState);
      const [appStateVisible, setAppStateVisible] = useState(appState.current);
      const [fooKey, setFooKey] = useState(1);
      const [doRefresh, setDoRefresh] = useState(false);
      const refreshFoo = () => setFooKey(fooKey + 1);
      const isFocused = useIsFocused();
      const dispatch = useDispatch();

      useEffect(() => {
        const unsubscribe = messaging().onMessage(
          async (remoteMessage = {}) => {
            const { data = {} } = remoteMessage;
            if (data.type && data.type === "FEED_REFRESH_EVENT") {
              dispatch(refreshActions.silentRefresh());
            }
          },
        );

        return unsubscribe;
      }, []);

      const _handleRefresh = () => {
        if (!lastFeedRefreshTimestamp) return;
        const currentTimeStamp =
          lastFeedRefreshTimestamp[screenName] ??
          lastFeedRefreshTimestamp[`${screenName}-${random}`] ??
          null;
        if (!currentTimeStamp) return;

        if (new Date() - currentTimeStamp > feedStaleDelayMs) {
          if (screenName === "PDP") {
            dispatch(
              refreshActions.setRefreshTimeStamp(`${screenName}-${random}`),
            );
          } else {
            dispatch(refreshActions.setRefreshTimeStamp(screenName));
          }
          if (selectedContact) {
            dispatch(cartActions.viewCartLiteRequest(selectedContact));
          }
          if (screenName === "Home") {
            dispatch(configActions.syncUser());
          }
          if (screenName === "Search") {
            setDoRefresh(true);
          } else refreshFoo();

          dispatch(qtySelectActions.hideBottomSheet());
        } else {
          if (screenName === "Search") {
            setDoRefresh(false);
          }
        }
      };

      const _handleAppStateChange = async (nextAppState) => {
        if (
          appState.current.match(/inactive|background/) &&
          nextAppState === "active"
        ) {
          if (isFocused) {
            _handleRefresh();
          }
        }

        appState.current = nextAppState;
        setAppStateVisible(appState.current);
      };

      useEffect(() => {
        const subscription = AppState.addEventListener(
          "change",
          _handleAppStateChange,
        );
        return () => {
          subscription.remove();
        };
      });

      useEffect(() => {
        if (screenName === "PDP") {
          dispatch(
            refreshActions.setRefreshTimeStamp(`${screenName}-${random}`),
          );
        } else {
          dispatch(refreshActions.setRefreshTimeStamp(screenName));
        }

        return () => {
          if (screenName === "PDP") {
            dispatch(
              refreshActions.resetRefreshTimeStamp(`${screenName}-${random}`),
            );
          } else {
            dispatch(refreshActions.resetRefreshTimeStamp(screenName));
          }
        };
      }, []);

      useFocusEffect(
        useCallback(() => {
          _handleRefresh();
        }, [isFocused]),
      );

      const componentProps =
        screenName === "Search"
          ? { ...props, doRefresh, resetDoRefresh: () => setDoRefresh(false) }
          : { ...props };
      return <WrappedComponent {...componentProps} key={fooKey} />;
    };
  };

export default refreshHOC;
